import { IProductGroupModel, IProductGroupPutModel } from "./model/IProductGroupModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class ProductGroupService extends ServiceBase {

    public async getProductGroups(
        organizationId: string,
    ): Promise<Result<IProductGroupModel[]>> {
        let url = "/Organization/" + organizationId + "/ProductGroups";

        var result = await this.requestJson<IProductGroupModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async postProductGroups(
        organizationId: string,
        name: string,
        vatId: number,
        taxableSales: number,
        taxableDiscount: number,
        nonTaxableSales: number,
        nonTaxableDiscount: number
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/ProductGroups";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: {
                name: name,
                vatId: vatId,
                taxableSales: taxableSales,
                taxableDiscount: taxableDiscount,
                nonTaxableSales: nonTaxableSales,
                nonTaxableDiscount: nonTaxableDiscount
            }
        });
        return result;
    }
    public async putProductGroup(
        organizationId: string, id: number, data: IProductGroupPutModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/ProductGroups/" + id;

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        })
        return result;
    }
}